import InternetImg from "public/network-services/icons/internet-dci.png";
import SocImg from "public/network-services/icons/noc-soc-helpdesk.png";
import MonitoringImg from "public/network-services/monitoring.svg";

export const ADVANTAGES_CONSTANTS = [
  {
    image: InternetImg,
    title: "NOC",
    text: "Proactive monitoring and management to maintain network health, performance, and availability.",
  },
  {
    image: SocImg,
    title: "SOC",
    text: "Continuous threat detection, analysis, and response to safeguard your environment against evolving cyber risks.",
  },
  {
    image: MonitoringImg,
    title: "IT Helpdesk",
    text: "Responsive technical support for end-users, resolving issues quickly and minimizing downtime.",
  },
];
